export const TiposProdutos = [
    {sigla: "P", descricao: "Produto para revenda"},
    {sigla: "M", descricao: "Matéria prima"},
    {sigla: "S", descricao: "Serviço"},
]

export const OrigensMercadoria = [    
    //{codigo: -1, descricao: ""},
    {codigo: 0, descricao: "Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8"},
    {codigo: 1, descricao: "Estrangeira – Importação direta, exceto a indicada no código 6"},
    {codigo: 2, descricao: "Estrangeira – Adquirida no mercado interno, exceto a indicada no código 7."},
    {codigo: 3, descricao: "Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% (quarenta por cento) e inferior ou igual a 70% (setenta por cento)."},
    {codigo: 4, descricao: "Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos (PPB) de que tratam o Decreto-Lei nº 288/1967, e as Leis nºs 8.248/1991, 8.387/1991, 10.176/2001 e 11.484/2007."},
    {codigo: 5, descricao: "Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40% (quarenta por cento)."},
    {codigo: 6, descricao: "Estrangeira – Importação direta, sem similar nacional, constante em lista de Resolução CAMEX e gás natural."},
    {codigo: 7, descricao: "Estrangeira – Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução CAMEX e gás natural."},
    {codigo: 8, descricao: "Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70% (setenta por cento)."},
]

export const RegimesTributarios = [
    {codigo: 'MEI', descricao: "Micro Empreendedor Individual"},
    {codigo: 'LR', descricao: "Lucro Real"},
    {codigo: 'LP', descricao: "Lucro Presumido"},
    {codigo: 'SN', descricao: "Simples Nacional"},
]